import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { Tooltip } from '@mui/material';
import { getFullName } from '@src/utilities/nameHelper';
import classNames from 'classnames';
import { useLocale } from 'pe-core-frontend';
import styles from '../PaymentRequestStatusTag/PaymentRequestStatusTag.module.scss';
export const PaymentRequestInProcessTag = ({ paymentRequest, size = 'small', }) => {
    const { t } = useLocale();
    if (!paymentRequest.inProcess || !paymentRequest.processedBy) {
        return null;
    }
    return (_jsx("div", { children: _jsx("div", { className: classNames(styles.tag, size === 'large' && styles.large), style: {
                color: 'var(--text-color-1)',
                backgroundColor: 'var(--background-color-1-tint-1)',
                borderColor: 'var(--background-color-1)',
            }, children: _jsx(Typography, { variant: size === 'large' ? 'body1' : 'label2', weight: '400', className: styles.status, children: _jsx(Tooltip, { title: t('Processing - {user}', {
                        values: { user: getFullName(paymentRequest.processedBy) },
                    }), children: _jsx("span", { children: t('In process') }) }) }) }) }));
};
